import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { isEqual } from 'lodash-es';

export enum BoolIconRendererIconType {
    AngularMaterial = 0,
    SeSvg = 1,
    SeFont = 2
}

interface IBoolIconRendererConfig {
    icon: string;
    negate: boolean;
    tooltip?: string;
    iconType?: BoolIconRendererIconType
}

type IBoolIconRendererParams = ICellRendererParams & { estensa: IBoolIconRendererConfig };

@Component({
    selector: 'se-bool-icon-renderer',
    templateUrl: './bool-icon-renderer.component.html',
    styleUrls: ['./bool-icon-renderer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoolIconRendererComponent implements ICellRendererAngularComp {
    config: IBoolIconRendererConfig;

    isActive = false;

    refresh(params: IBoolIconRendererParams): boolean {
        const shouldRefresh = !isEqual(params.value, this.isActive) || !isEqual(params.estensa, this.config);

        if (shouldRefresh) {
            this.config = params.estensa;
            this.isActive = params.value;

            if (params.estensa.negate) {
                this.isActive = !this.isActive;
            }
        }

        return shouldRefresh;
    }

    agInit(params: IBoolIconRendererParams): void {
        this.refresh(params);
    }
}
